import { SlotLabelContentArg } from "@fullcalendar/core"
import { useTranslation } from "react-i18next"
import { CustomSlotLabelCalendarWrapper } from "./styles"

interface IProps {
	info: SlotLabelContentArg
}

// The calendar runs on timeZone="utc", so every slot date is a UTC-midnight
// instant standing for a plain calendar day. Read its parts in UTC -- reading
// them locally lands on the previous day west of UTC, which is what paired the
// wrong weekday name with the day number and marked the wrong cell as today.
const istoday = (date: Date) => {
	const today = new Date()
	return (
		date.getUTCDate() === today.getDate() &&
		date.getUTCMonth() === today.getMonth() &&
		date.getUTCFullYear() === today.getFullYear()
	)
}
const isWeekEnd = (date: Date) => {
	const day = date.getUTCDay()
	if (day === 5 || day === 6) {
		return true
	}
	return false
}
export default function CustomSlotLabelCalendar({ info }: IProps) {
	const {
		i18n: { language },
	} = useTranslation()
	const date = info.date
	const numberOfDays = `${date.getUTCDate()}`
	const options: Intl.DateTimeFormatOptions = { weekday: "long", timeZone: "UTC" } // Set options to get long weekday name
	const dayName = new Intl.DateTimeFormat(language, options).format(date) // Get the day name

	return (
		<CustomSlotLabelCalendarWrapper
			$isWeekEnd={isWeekEnd(date)}
			$istoday={istoday(date)}
		>
			<p>{dayName}</p>
			<p>
				<span>{numberOfDays}</span>
			</p>
		</CustomSlotLabelCalendarWrapper>
	)
}
